// Custom logging
// https://stackoverflow.com/a/32928812
window.debug = (process.env.NODE_ENV !== 'production') ? window.console.log.bind(window.console) : () => {};

// Vendor
import { Ajaxinate } from 'ajaxinate';

// Elements
import CartMessage from './elements/cart-message';
import CartUpsells from './elements/cart-upsells';
import SizeChart from './elements/size-chart';
import SubcategoryNav from './elements/subcategory-nav';

document.addEventListener('DOMContentLoaded', function () {
    // Init elements
    customElements.define('cart-message', CartMessage);
    customElements.define('cart-upsells', CartUpsells);
    customElements.define('size-chart', SizeChart);
    customElements.define('subcategory-nav', SubcategoryNav);
    
    // Predictive search
    document.addEventListener('predictive-search:open', () => {
        if (document.body.classList.contains('template-index')) {
            document.querySelector('.header-wrapper').classList.remove('is-light');
            document.querySelector('.site-header').classList.add('search-active');
        }
    
        debug('Predictive search open');
    });
    document.addEventListener('predictive-search:close-all', () => {
        if (document.body.classList.contains('template-index')) {
            document.querySelector('.header-wrapper').classList.add('is-light');
            document.querySelector('.site-header').classList.remove('search-active');
        }
    
        debug('Predictive search close');
    });
    
    // Size chart drawer
    theme.SizeChartDrawer = (function() {
      var selectors = {
        drawer: '#SizeChartDrawer',
        table: '#SizeChartDrawer table'
      };
    
      function SizeChartDrawer() {
        this.table = document.querySelector(selectors.table);
        this.drawer = new theme.Drawers('SizeChartDrawer', 'size-chart');
    
        this.init();
      }
    
      SizeChartDrawer.prototype = Object.assign({}, SizeChartDrawer.prototype, {
        init: function() {    
          // Dev-friendly way to open cart
          document.addEventListener('size-chart:open', this.open.bind(this));
          document.addEventListener('size-chart:close', this.close.bind(this));
        },
    
        open: function() {
          this.drawer.open();
    
          theme.a11y.trapFocus({
            container: this.table,
            elementToFocus: this.table,
            namespace: 'sizechartdrawer_focus'
          });
        },
    
        close: function() {
          this.drawer.close();
    
          theme.a11y.removeTrapFocus({
            container: this.table,
            namespace: 'sizechartdrawer_focus'
          });
        }
      });
    
      return SizeChartDrawer;
    })();
    
    if (document.querySelector('#SizeChartDrawer')) {
        new theme.SizeChartDrawer();   
    }

    // Infinite scroll for sections/same-main-collection-infinite.liquid
    if (document.querySelector('#AjaxinateContainer')) {
        var endlessScroll = new Ajaxinate({
            container: '#AjaxinateContainer',
            pagination: '#AjaxinatePagination',
            loadingText: 'Loading More',
            callback: () => {
                if (typeof AOS == 'object') {
                    debug('Ajaxinate callback');
                    AOS.init();
                }
            },
        });
    }    
});
